module.exports = __webpack_public_path__ + "media/icons/radiogray-67702160.png";